/** Подтверждение очистки чертежа через общий модальный компонент интерфейса. */
import { UIKit } from "@/shared/ui";

type EditorResetPlanDialogProps = {
	onConfirm: () => void;
	onClose: () => void;
};

export const EditorResetPlanDialog = ({ onConfirm, onClose }: EditorResetPlanDialogProps) => (
	<UIKit.ConfirmModal
		title="Сбросить чертёж?"
		description="С плана уберётся всё: стены, проёмы, мебель, электрика, трубы и комментарии. Вернуть можно кнопкой «Отменить» или Ctrl+Z."
		actions={
			<>
				<UIKit.Button onClick={onClose}>Отмена</UIKit.Button>
				<UIKit.Button
					autoFocus
					className="border-danger bg-danger text-overlay-ink hover:border-danger"
					onClick={onConfirm}
				>
					Сбросить
				</UIKit.Button>
			</>
		}
		onClose={onClose}
	/>
);
